import { AlertTriangle, ArrowLeft, RotateCcw } from 'lucide-react';
import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BrandLogo } from '@/components/brand/brand-logo';
import { Button, buttonVariants } from '@/components/ui';
import { routes } from '@/lib/routes';

export function RouteErrorPage() {
  const error = useRouteError();
  const { t } = useTranslation('common');
  const isNotFound = isRouteErrorResponse(error) && error.status === 404;
  return (
    <main className="route-error route-error--standalone">
      <BrandLogo />
      <span className="route-error__icon">
        <AlertTriangle size={26} />
      </span>
      <h1>{isNotFound ? t('status.notFoundTitle') : t('status.pageErrorTitle')}</h1>
      <p>{isNotFound ? t('status.notFoundBody') : t('status.pageErrorBody')}</p>
      <div>
        <Button onClick={() => window.location.reload()}>
          <RotateCcw size={17} /> {t('actions.tryAgain')}
        </Button>
        <Link to={routes.home} className={buttonVariants({ variant: 'secondary' })}>
          <ArrowLeft className="rtl-flip" size={17} /> {t('actions.goHome')}
        </Link>
      </div>
    </main>
  );
}
